const enMessages = {
  // datepicker: {
  //   toggleCalendar: 'Takvimi aç/kapat',
  // },
  // calendar: {
  //   today: 'Bugün',
  // },
  // dateinput: {
  //   increment: 'Değeri artır',
  //   decrement: 'Değeri azalt',
  // },
  // numerictextbox: {
  //   increment: 'Değeri artır',
  //   decrement: 'Değeri azalt',
  // },
  grid: {
    // groupPanelEmpty: 'Drag a column header and drop it here to group by that column',
    // pagerItemsPerPage: 'Items per page',
    // pagerInfo: '{0} - {1} / {2} items',
    // pagerFirstPage: 'Go to the first page',
    // pagerPreviousPage: 'Go to the previous page',
    // pagerNextPage: 'Go to the next page',
    // pagerLastPage: 'Go to the last page',
    // pagerPage: 'Page',
    // pagerOf: '/',
    // pagerTotalPages: '{0}',
    // pagerItemPerPage: '	items per page',
    // filterClearButton: 'Clear',
    // filterEqOperator: 'Is equal to',
    // filterNotEqOperator: 'Is not equal to',
    // filterIsNullOperator: 'Is null',
    // filterIsNotNullOperator: 'Is not null',
    // filterIsEmptyOperator: 'Is empty',
    // filterIsNotEmptyOperator: 'Is not empty',
    // filterStartsWithOperator: 'Starts with',
    // filterContainsOperator: 'Contains',
    // filterNotContainsOperator: '	Does not contain',
    // filterEndsWithOperator: 'Ends with',
    // filterGteOperator: 'Is greater than or equal to',
    // filterGtOperator: 'Is greater than',
    // filterLteOperator: 'Is less than or equal to',
    // filterLtOperator: 'Is less than',
    filterIsTrue: 'Deactive',
    filterIsFalse: 'Active',
    // filterBooleanAll: '(All)',
    // filterAfterOrEqualOperator: '	Is after or equal to',
    // filterAfterOperator: 'Is after',
    // filterBeforeOperator: '	Is before',
    // filterBeforeOrEqualOperator: 'Is before or equal to',
    // filterSubmitButton: 'Filter',
    // filterAndLogic: 'And',
    // filterOrLogic: 'Or',
    // filterTitle: 'Filter',
    // filterChooseOperator: 'Choose Operator',
    // filterSelectedItems: 'selected items',
    // filterAriaLabel: 'Filter',
    // sortAscending: 'Sort Ascending',
    // sortDescending: 'Sort Descending',
    // sortAriaLabel: 'Sortable',
    // searchPlaceholder: 'Search',
    // noRecords: '	No records available.',
    // filterCheckAll: '	Check All',
    // groupColumn: 'Group Column',
    // groupExpand: 'Expand group',
    // groupCollapse: 'Collapse Group',
    // groupPanelAriaLabel: 'Group panel',
    // gridAriaLabel: 'Table',
    // ungroupColumn: 'Ungroup Column',
    // detailExpand: '	Expand detail row',
    // detailCollapse: 'Collapse detail row',
  },
}
export default enMessages;

